





































import {Component, Vue} from "vue-property-decorator";
import {Action, Getter} from "vuex-class";
import Table from "@/components/Table/Table.vue";
import TableActionEdit from "@/components/Table/ActionButtons/Edit.vue";
import AppConfig from "@/config/AppConfig";
import PostsOverviewItem from "@/views/Blog/Posts/PostsOverview/PostsOverviewItem.vue";
import App from "@/App.vue";

const namespace = 'posts';

@Component({
  components: {PostsOverviewItem, TableActionEdit, Table}
})
export default class PostsList extends Vue {
  public name: string = "PostsList";

  @Action("load", {namespace}) load: any;

  @Action("destroy", {namespace}) deleteItem: any;

  @Getter('getDataList', {namespace}) dataList: any;

  @Getter('getPaginationData', {namespace}) getPaginationData: any;

  private params: any = {};
  private appConfig: AppConfig = new AppConfig;

  get resource() {

    let blogSlug: string = this.$route.params.blog;

    return 'blog/' + blogSlug + '/post';

  }

  private dateTimeFormat(): string {

    return AppConfig.DATETIME_FORMAT_FRONTEND;

  }

  private getTableColumns(): any {

    console.log('getTableBla', AppConfig.getTableConfig('Blog.Posts').columns);

    return AppConfig.getTableConfig('Blog.Posts').columns;

  }

  private onFiltersChanged(filters: any): void {

    // removed console_log
    this.params['filters'] = filters;
    this.load({resource: this.resource, params: this.params});

  }

  private onOrderChanged(orderParams: any) {

    // removed console_log

    if (!!orderParams) {
      this.params['order'] = {
        orderBy: orderParams.column,
        direction: orderParams.direction
      }

    } else if (!orderParams && this.params.hasOwnProperty('order')) {

      delete this.params.order;

    }

    this.load({resource: this.resource, params: this.params});

  }

  mounted() {
    // removed console_log
    this.load({resource: this.resource, params: {}});
  }

}
